let config = require('../Config/appConfig.json');
const build_version = config.BUILD_VERSION;
var ConsoleLogger = (function () {
   

    var log = function (context,text) {
        
        if(build_version === "DEV"){
            console.log("In => "+context +" TEXT ==> "+text);
        }
        
       
    }

    return {
        log: log
    }

})();

export default ConsoleLogger;


// WEBPACK FOOTER //
// ./src/Utils/ConsoleLogger.js